import type { VirtualFile } from "@pdfking/pdfengine"

import type { FileObject } from "../types/FileObject"
import new_file_from_factory from "./new_file_from_factory"

export default ({
  path,
  file,
}: {
  path: string
  file: VirtualFile
}): FileObject =>
  new_file_from_factory({
    path,
    file_meta: file.file_meta,
    factory: async () => file,
  })
